import { Controller } from "@hotwired/stimulus"

// Toggle entre les blocs file / video / audio selon le document_format sélectionné.
// - format=video : on cache file, on affiche video, l'audio (s'il existe) est caché
// - format=audio : on cache video, on affiche audio + on garde file visible (upload OU url)
// - sinon : on affiche file, on cache video et audio
export default class extends Controller {
  static targets = [
    "format",
    "fileBlock", "fileInput",
    "videoBlock", "videoInput",
    "audioBlock", "audioInput"
  ]

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.formatTarget.value
    const isVideo = value === "video"
    const isAudio = value === "audio"

    // File block : visible sauf en mode vidéo. En mode audio reste visible (upload reste possible).
    if (this.hasFileBlockTarget) {
      this.fileBlockTarget.classList.toggle("hidden", isVideo)
    }
    if (this.hasFileInputTarget) {
      // Le fichier est requis sauf en vidéo ; en audio il devient optionnel (URL externe alternative).
      this.setRequired(this.fileInputTarget, !isVideo && !isAudio)
    }

    if (this.hasVideoBlockTarget) {
      this.videoBlockTarget.classList.toggle("hidden", !isVideo)
    }
    if (this.hasVideoInputTarget) {
      this.setRequired(this.videoInputTarget, isVideo)
    }

    if (this.hasAudioBlockTarget) {
      this.audioBlockTarget.classList.toggle("hidden", !isAudio)
    }
    // L'audio_url n'est jamais HTML-required : la validation serveur exige file OU url.
    if (this.hasAudioInputTarget) {
      this.setRequired(this.audioInputTarget, false)
    }
  }

  setRequired(element, required) {
    if (required) {
      element.setAttribute("required", "required")
      element.setAttribute("aria-required", "true")
    } else {
      element.removeAttribute("required")
      element.removeAttribute("aria-required")
    }
  }
}
